import React, { Fragment, useEffect, useState, useContext, useRef } from "react";
import { teacherProfile, changeStatus, loginOtp, enableForPaid, enableForAllocationPriority, enableForNightSlots, resetotp, getTeacherMappedCourses } from "../../../../Api/apiUtils";
import { Input, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { FaEnvelope, FaPhone } from "react-icons/fa";
import { ConfigContext, } from "../../../../Api/global/ApiContext";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css"; 
import { toast } from "react-toastify";
import { MdInstallMobile } from "react-icons/md";
import { IoShareSocial } from "react-icons/io5";
import { FaCopy } from 'react-icons/fa';
import { MixpanelEvents,trackEvent } from "../../../../utils/mixpanelTracking"; 
import { Link } from 'react-router-dom';
import { IoReceiptOutline } from "react-icons/io5";
import { isTeacherLeader, isTeacherLeaderDisabled } from "../../../../utils/permissions";
import ClickToCall from "../../../../Telephony/ClickToCall";
import FormProfile from "./FormProfile";
import { LinkWithHref } from "../../../../utils/Constant";
import {
  buildTeacherChatUrl,
  isTeacherViewChatEnabled,
} from "./teacherDashboardLinks";
import { openDashboardWithAuth } from "../../../../utils/dashboardHandoff";
import { Badge, Button, Disclosure, EmptyState, Field, Loader, Select, TextInput } from "../../../../ui";
import type { BadgeTone, SelectOption } from "../../../../ui";
import TeacherStatusBadge from "./ui-pending/TeacherStatusBadge";
import ActionTile, { ActionTileContent, actionTileClass } from "./ui-pending/ActionTile";
import SwitchField from "./ui-pending/SwitchField";
import "./home.scss";

/** Working statuses this panel sets; ACTIVE is already in the shared map. */
const WORKING_STATUS_TONES: Record<string, BadgeTone> = {
  resigned: "warning",
  terminated: "danger",
};

const STATUS_OPTIONS: SelectOption[] = [
  { value: "ACTIVE", label: "Active" },
  { value: "RESIGNED", label: "Resign" },
  { value: "TERMINATED", label: "Terminate" },
];

const OTHER_REASON = "Other (please specify)";

const RESIGNATION_REASONS: SelectOption[] = [
  { value: "Personal commitments (family, marriage, caregiving)", label: "Personal commitments (family, marriage, caregiving)" },
  { value: "Health reasons", label: "Health reasons" },
  { value: "Relocation or moving abroad", label: "Relocation or moving abroad" },
  { value: "Better opportunity (another job or platform)", label: "Better opportunity (another job or platform)" },
  { value: "Higher studies", label: "Higher studies" },
  { value: "Pursuing own teaching or performing career", label: "Pursuing own teaching or performing career" },
  { value: "Time or schedule conflict with Artium slots", label: "Time or schedule conflict with Artium slots" },
  { value: "Low student count or low earnings", label: "Low student count or low earnings" },
  { value: "Payout or pay structure", label: "Payout or pay structure" },
  { value: "Policy change (class, leave or payout policy)", label: "Policy change (class, leave or payout policy)" },
  { value: "Dissatisfaction with support or organization.", label: "Dissatisfaction with support or organization." },
  { value: "Not interested in teaching online", label: "Not interested in teaching online" },
  { value: OTHER_REASON, label: OTHER_REASON },
];

const TERMINATION_REASONS: SelectOption[] = [
  { value: "Disciplinary issues (misconduct, behaviour with learners or staff)", label: "Disciplinary issues (misconduct, behaviour with learners or staff)" },
  { value: "Quality concerns (repeated low QA scores, no improvement after feedback)", label: "Quality concerns (repeated low QA scores, no improvement after feedback)" },
  { value: "Policy violation (taking learners off-platform, sharing contact details, etc.)", label: "Policy violation (taking learners off-platform, sharing contact details, etc.)" },
  { value: "Frequent no-shows or late cancellations", label: "Frequent no-shows or late cancellations" },
  { value: "Poor attendance or low class completion", label: "Poor attendance or low class completion" },
  { value: "Unresponsive (not replying to the team, not following instructions)", label: "Unresponsive (not replying to the team, not following instructions)" },
  { value: "Learner complaints (escalated and verified)", label: "Learner complaints (escalated and verified)" },
  { value: "Credential or profile mismatch (qualification or experience not as stated)", label: "Credential or profile mismatch (qualification or experience not as stated)" },
  { value: "Inactivity (no classes or availability for an extended period)", label: "Inactivity (no classes or availability for an extended period)" },
  { value: "Contract end or non-renewal", label: "Contract end or non-renewal" },
  { value: OTHER_REASON, label: OTHER_REASON },
];

const isOffboardStatus = (status: string) => status === "RESIGNED" || status === "TERMINATED";

const buildTeacherDashboardUrl = (teacherId: string) => {
  const base = `http://betadashboard.artiumacademy.com/?teacherId=${teacherId}`;
  // Only Teacher Leaders need the flag so dashboard v2 can hide My Earnings.
  return isTeacherLeader() ? `${base}&teacherLeaderView=1` : base;
};

interface HomeProps {
  credentialId: string;
  teacherId: string;
  fetchData: () => Promise<void>; 
  teacherDetails: any;
}

const Home: React.FC<HomeProps> = ({ credentialId, teacherId, fetchData , teacherDetails}) => {
  const readOnly = isTeacherLeaderDisabled();

  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [selectedStatus, setSelectedStatus] = useState<string>("ACTIVE");
  const [lastDate, setLastDate] = useState<Date | null>(null);
  const [statusReasonCode, setStatusReasonCode] = useState<string>("");
  const [statusReasonOther, setStatusReasonOther] = useState<string>("");
  const [statusReason, setStatusReason] = useState<string>("");
  const [statusUpdating, setStatusUpdating] = useState(false);
  const statusUpdatingRef = useRef(false);
  const [otp, setOtp] = useState<string>("");const [isOtpModalOpen, setIsOtpModalOpen] = useState(false);
  const [otpLoading, setOtpLoading] = useState(false);
  const otpRequestInFlight = useRef(false);
  const config = useContext(ConfigContext);
  const [isPaidEnabled, setIsPaidEnabled] = useState<boolean>(false);
  const [isNightSlotEnable, setIsNightSlotEnable] = useState(false);
  const [nightSlotAction, setNightSlotAction] = useState(false);
  const [isNightSlotReasonModalOpen, setIsNightSlotReasonModalOpen] = useState(false);
    const [isAllocattionPriority, setIsAllocattionPriority] = useState<boolean>(false);
  const [isReasonModalOpen, setIsReasonModalOpen] = useState<boolean>(false);
  const [selectedReason, setSelectedReason] = useState<string>("");
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const [customReason, setCustomReason] = useState('');
  const [showCustomReasonInput, setShowCustomReasonInput] = useState(false);
  const [action, setAction] = useState<boolean>(false); 
  const disableReasons = config?.TeacherToggleButtonDisableReason || [];
  const enableReasons = config?.TeacherToggleButtonEnableReason || [];
  const [showResetModal, setShowResetModal] = useState(false);
  const [resetLoading, setResetLoading] = useState(false);
  const [mappedCourses, setMappedCourses] = useState<
    { courseName: string; courseId?: string; levels: string[] }[]
  >([]);
  const [coursesLoading, setCoursesLoading] = useState(false);
  const [coursesOpen, setCoursesOpen] = useState(false);

  useEffect(() => {
    if (teacherDetails?.teacherProfileDetails) {
      setIsPaidEnabled(!!teacherDetails.teacherProfileDetails.enableForPaid);
      setIsAllocattionPriority(!!teacherDetails.allocationPriority);
      setIsNightSlotEnable(!!teacherDetails.enableNightSlots);
    }
  }, [
    teacherDetails?.teacherProfileDetails?.enableForPaid,
    teacherDetails?.allocationPriority,
    teacherDetails?.enableNightSlots
  ]);

  useEffect(() => {
    if (!teacherId) return;
    let cancelled = false;
    const loadCourses = async () => {
      setCoursesLoading(true);
      try {
        const list = await getTeacherMappedCourses(teacherId);
        if (cancelled) return;
        const levelOrder = ["Preparatory", "Intermediate", "Proficient", "Advanced"];
        const byName = new Map<string, { courseName: string; courseId?: string; levels: string[] }>();
        list.forEach((item) => {
          const name = item.courseName || "Untitled course";
          const existing = byName.get(name);
          if (!existing) {
            byName.set(name, {
              courseName: name,
              courseId: item.courseId,
              levels: item.level ? [item.level] : [],
            });
          } else if (item.level && !existing.levels.includes(item.level)) {
            existing.levels.push(item.level);
          }
        });
        setMappedCourses(
          Array.from(byName.values()).map((course) => ({
            ...course,
            levels: [...course.levels].sort(
              (a, b) => levelOrder.indexOf(a) - levelOrder.indexOf(b)
            ),
          }))
        );
      } catch (error) {
        console.error("Error fetching teacher courses:", error);
        if (!cancelled) setMappedCourses([]);
      } finally {
        if (!cancelled) setCoursesLoading(false);
      }
    };
    void loadCourses();
    return () => {
      cancelled = true;
    };
  }, [teacherId]);

  const fetchOtp = async () => {
    try {
      const response = await loginOtp(credentialId);
      console.log("OTP Response:", response);
      setOtp(response.data?.OTP);
      setIsOtpModalOpen(true);
    } catch (error) {
      console.error("Error fetching OTP:", error);
    } finally {
      otpRequestInFlight.current = false;
      setOtpLoading(false);
    }
  };
 
  const handleReasonChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSelectedReason(value);
    setShowCustomReasonInput(value === 'Others');
    if (value !== 'Others') {
      setCustomReason(''); // Clear custom reason if not "Other"
    }
  };

  const handleToggle = () => {
   
    setIsReasonModalOpen(true);

    setAction(!isPaidEnabled);
  };
  const handleConfirm = async () => {

    const finalReason = selectedReason === 'Others' ? customReason : selectedReason;
    try {
  
      await enableForPaid(teacherId, action);
      await fetchData();
      setIsPaidEnabled(action);
      setIsReasonModalOpen(false);
      trackEvent(MixpanelEvents.ENABLE_FOR_PAID, {
        page:"Teacher Profile",
        "TeacherId":teacherId,
         "Action":action,
       "TeacherName":teacherDetails?.teacherProfileDetails?.firstName
            });
     toast.success(`Teacher ${action ? "enabled" : "disabled"} for paid successfully!`);

    } catch (error) {
      console.error("Error updating enable for paid status:", error);
    toast.error("Failed to update enable for paid status.");
    }
  };
  const resetStatusForm = () => {
    setLastDate(null);
    setStatusReasonCode("");
    setStatusReasonOther("");
    setStatusReason("");
    setStatusUpdating(false);
    statusUpdatingRef.current = false;
  };

  const toggleModal = () => {
    if (statusUpdatingRef.current) return;
    setIsModalOpen(!isModalOpen);
    if (!isModalOpen) resetStatusForm();
  };

  const offboardReasonOptions =
    selectedStatus === "RESIGNED"
      ? RESIGNATION_REASONS
      : selectedStatus === "TERMINATED"
        ? TERMINATION_REASONS
        : [];

  const resolvedOffboardReason =
    statusReasonCode === OTHER_REASON
      ? statusReasonOther.trim()
      : statusReasonCode.trim();

  const canSubmitStatus = (() => {
    if (statusUpdating) return false;
    if (isOffboardStatus(selectedStatus)) {
      if (!statusReasonCode) return false;
      if (statusReasonCode === OTHER_REASON && !statusReasonOther.trim()) return false;
      if (!lastDate) return false;
      return true;
    }
    return Boolean(statusReason.trim());
  })();

  const handleStatusChange = async () => {
    if (statusUpdatingRef.current) return;
    try {
      const reason = isOffboardStatus(selectedStatus)
        ? resolvedOffboardReason
        : statusReason.trim();

      if (!reason) {
        toast.warning(
          isOffboardStatus(selectedStatus)
            ? statusReasonCode === OTHER_REASON
              ? "Please specify the other reason."
              : "Please select a reason."
            : "Please enter a reason (max 300 characters).",
        );
        return;
      }
      if (reason.length > 300) {
        toast.warning("Reason cannot exceed 300 characters.");
        return;
      }
      if (isOffboardStatus(selectedStatus) && !lastDate) {
        toast.warning("Please select the last working day.");
        return;
      }

      const mobileNumber = teacherDetails.teacherProfileDetails.mobileNumber;

      const pad = (value: number) => String(value).padStart(2, "0");
      const queryLastDate = lastDate
        ? `${lastDate.getFullYear()}-${pad(lastDate.getMonth() + 1)}-${pad(lastDate.getDate())} ${pad(lastDate.getHours())}:${pad(lastDate.getMinutes())}:${pad(lastDate.getSeconds())}`
        : undefined;
      const bodyLastDate = lastDate
        ? lastDate.toISOString().replace("T", "+").replace(/\.\d{3}Z$/, "")
        : undefined;

      statusUpdatingRef.current = true;
      setStatusUpdating(true);
      await changeStatus(mobileNumber, selectedStatus, queryLastDate, reason, bodyLastDate);
      trackEvent(MixpanelEvents.TEACHER_STATUS_CHANGE, {
        page: "Teacher Profile",
        TeacherId: teacherId,
        TeacherName: teacherDetails?.teacherProfileDetails?.firstName,
        Status: selectedStatus,
        Reason: reason,
        ReasonCode: isOffboardStatus(selectedStatus) ? statusReasonCode : null,
        LastDate: queryLastDate || null,
        action: "success",
      });
      await fetchData();
      toast.success("Status updated successfully!");
      statusUpdatingRef.current = false;
      setStatusUpdating(false);
      setIsModalOpen(false);
      resetStatusForm();
    } catch (error) {
      console.error("Error updating status:", error);
      trackEvent(MixpanelEvents.TEACHER_STATUS_CHANGE, {
        page: "Teacher Profile",
        TeacherId: teacherId,
        TeacherName: teacherDetails?.teacherProfileDetails?.firstName,
        Status: selectedStatus,
        Reason: isOffboardStatus(selectedStatus) ? resolvedOffboardReason || null : statusReason.trim() || null,
        action: "failed",
        error: error instanceof Error ? error.message : String(error || ""),
      });
      toast.error("Failed to update status.");
      statusUpdatingRef.current = false;
      setStatusUpdating(false);
    }
  };

  function isImageUrl(url: string): boolean {
    if (!url) return false;
    try {
      new URL(url);
      return /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(url) || 
             url.startsWith('data:image/') || 
             url.startsWith('blob:');
    } catch {
      return false;
    }
  }
  
  function getInitials(firstName?: string, lastName?: string): string {
    const first = firstName?.trim().charAt(0)?.toUpperCase() || '';
    const last = lastName?.trim().charAt(0)?.toUpperCase() || '';
    return first + (last && first ? last : '');
  }
  const nightSlotToggle = (e: React.ChangeEvent<HTMLInputElement>) => {
    const checked = e.target.checked;
    setNightSlotAction(checked);          // store the intended action
    setIsNightSlotReasonModalOpen(true);  // open modal
  };
  
  // When user confirms
  const nightSlotConfirm = async () => {
    try {
      await enableForNightSlots(teacherId, nightSlotAction);
  
      setIsNightSlotEnable(nightSlotAction); 
      await fetchData();
  
      setIsNightSlotReasonModalOpen(false);
      toast.success(`Teacher ${nightSlotAction ? "enabled" : "disabled"} for night slots successfully!`);
    } catch (error) {
      console.error("Failed to update night slot status.", error);
      toast.error("Failed to update night slot status.");
    }
  };
  
  // When user cancels
  const nightSlotCancel = () => {
    setIsNightSlotReasonModalOpen(false);
    setNightSlotAction(isNightSlotEnable); // revert back to original state
  };
  
  
  
  
  

  

  const changeallocationPriority = async () => {
    try {
      const res = await enableForAllocationPriority({
       "teacherId": teacherId,
       "value": !isAllocattionPriority
      });
      if(res.status === 200) {
        setIsAllocattionPriority(!isAllocattionPriority);
        toast.success("Allocation priority updated successfully!");
      }else{
        toast.error("Failed to update allocation priority.");
      }
    } catch (error) {
      console.error("Error updating allocation priority:", error);
      toast.error("Failed to update allocation priority.");
    }
  };
  const profile = teacherDetails?.teacherProfileDetails;
  const leaderDisabledTitle = readOnly ? "Disabled for Teacher Leaders" : undefined;
  const paidReasons: string[] = action ? enableReasons : disableReasons;

  return (
    <div className="tp-home">
      {teacherDetails ? (
        <>
          <div className="tp-home__actions">
            <ActionTile
              onClick={() => { if (readOnly) return; toggleModal(); }}
              disabled={readOnly}
              title={leaderDisabledTitle}
              icon={
                <TeacherStatusBadge
                  status={teacherDetails.teacherProfileDetails.workingStatus}
                  label={teacherDetails.teacherProfileDetails.workingStatus}
                  tones={WORKING_STATUS_TONES}
                />
              }
              label="Change Working Status"
            />
            <ActionTile
              onClick={() => { if (readOnly) return; setShowResetModal(true); }}
              disabled={readOnly}
              title={leaderDisabledTitle}
              icon={<MdInstallMobile size={20} aria-hidden />}
              label="Reset OTP"
            />
            <ActionTile
              onClick={() => {
                if (readOnly || otpLoading || otpRequestInFlight.current) return;
                otpRequestInFlight.current = true;
                setOtpLoading(true); // disable immediately on click
                void fetchOtp();
              }}
              disabled={readOnly || otpLoading}
              aria-busy={otpLoading || undefined}
              title={readOnly ? "Disabled for Teacher Leaders" : otpLoading ? "Fetching OTP…" : undefined}
              icon={<MdInstallMobile size={20} aria-hidden />}
              label={otpLoading ? "Fetching…" : "Get OTP"}
            />
            <a
              className={actionTileClass}
              href={buildTeacherDashboardUrl(teacherId)}
              target="_blank"
              rel="noopener noreferrer"
              onClick={(e) => {
                e.preventDefault();
                openDashboardWithAuth(buildTeacherDashboardUrl(teacherId));
              }}
            >
              <ActionTileContent icon={<IoShareSocial size={20} aria-hidden />} label="View Dashboard" />
            </a>

            {/* {jwtToken && isTeacherViewChatEnabled() && (
              <a className={actionTileClass} href={buildTeacherChatUrl(teacherId)} target="_blank" rel="noopener noreferrer">
                <ActionTileContent icon={<IoShareSocial size={20} aria-hidden />} label="View Chat" />
              </a>
            )} */}

            <Link
              className={actionTileClass}
              to={readOnly ? "#" : `${process.env.PUBLIC_URL}/pages/teacher-ledger?teacherId=${teacherId}`}
              target={readOnly ? undefined : "_blank"}
              rel="noopener noreferrer"
              onClick={(e) => { if (readOnly) e.preventDefault(); }}
              aria-disabled={readOnly || undefined}
              title={leaderDisabledTitle}
            >
              <ActionTileContent icon={<IoReceiptOutline size={20} aria-hidden />} label="Teacher Ledger" />
            </Link>
          </div>

          <Modal isOpen={isReasonModalOpen} toggle={() => setIsReasonModalOpen(false)}>
            <ModalHeader toggle={() => setIsReasonModalOpen(false)}>
              {action ? "Enable for Paid" : "Disable for Paid"}
            </ModalHeader>
            <ModalBody>
              <fieldset className="tp-home__reasons">
                <legend className="tp-home__legend">Select reason</legend>
                {paidReasons.map((reason: string, index: number) => (
                  <div className="form-check" key={reason}>
                    <input
                      className="form-check-input"
                      type="radio"
                      id={`paid-reason-${index}`}
                      name="reason"
                      value={reason}
                      onChange={handleReasonChange}
                      checked={selectedReason === reason}
                    />
                    <label className="form-check-label" htmlFor={`paid-reason-${index}`}>
                      {reason}
                    </label>
                  </div>
                ))}
              </fieldset>

              {showCustomReasonInput && (
                <Field label="Please specify" id="customReason" className="tp-home__custom-reason">
                  {(control) => (
                    <TextInput
                      {...control}
                      type="text"
                      value={customReason}
                      onChange={(e) => setCustomReason(e.target.value)}
                      placeholder="Enter your reason"
                    />
                  )}
                </Field>
              )}
            </ModalBody>
            <ModalFooter>
              <Button variant="secondary" onClick={() => setIsReasonModalOpen(false)}>
                Cancel
              </Button>
              <Button
                variant="primary"
                onClick={handleConfirm}
                disabled={!selectedReason || (selectedReason === 'Other' && !customReason)}
              >
                Confirm
              </Button>
            </ModalFooter>
          </Modal>

          <div className="tp-home__identity">
            <div className="tp-home__avatar">
              {profile?.profilePhoto && isImageUrl(profile.profilePhoto) ? (
                <img
                  src={profile.profilePhoto}
                  alt="Profile"
                  className="tp-home__avatar-img"
                  onError={(e) => {
                    const target = e.target as HTMLImageElement;
                    target.style.display = 'none';
                    // Show fallback initials
                    const fallback = target.nextElementSibling as HTMLElement;
                    if (fallback) fallback.style.display = 'flex';
                  }}
                />
              ) : null}
              <div className={`tp-home__initials${profile?.profilePhoto ? " tp-home__initials--hidden" : ""}`}>
                {getInitials(profile?.firstName, profile?.lastName)}
              </div>
            </div>

            <div className="tp-home__details">
              <div className="tp-home__heading">
                <h3 className="tp-home__name">
                  {profile?.firstName} {profile?.lastName}
                </h3>
                <Badge tone={profile?.isAcademicExpert ? "accent" : "primary"}>
                  {profile?.isAcademicExpert ? "Academic Expert" : "Paid Teacher"}
                </Badge>
              </div>

              <div className="tp-home__contact">
                <div className="tp-home__contact-row">
                  <FaPhone size={14} aria-hidden />
                  <ClickToCall
                    number={
                      profile?.mobileNumber
                        ? `${profile?.countryCode || ""}${profile?.mobileNumber}`
                        : undefined
                    }
                    name={`${profile?.firstName || ""} ${profile?.lastName || ""}`.trim()}
                    sourceRecordId={teacherId}
                  />
                </div>
                <div className="tp-home__contact-row">
                  <FaEnvelope size={14} aria-hidden />
                  <span>{profile?.emailId}</span>
                </div>
              </div>

              <div className="tp-home__courses">
                <div className="tp-home__courses-title">
                  Courses
                  {!coursesLoading && mappedCourses.length > 0 ? (
                    <Badge tone="primary">{mappedCourses.length}</Badge>
                  ) : null}
                </div>
                {coursesLoading ? (
                  <Loader label="Loading courses…" />
                ) : mappedCourses.length === 0 ? (
                  <EmptyState
                    title="No courses tagged yet"
                    description="Map courses to this teacher in Course Tagging."
                  />
                ) : (
                  <Disclosure
                    open={coursesOpen}
                    onToggle={() => setCoursesOpen((open) => !open)}
                    summary={
                      <span>
                        {mappedCourses.length} course{mappedCourses.length === 1 ? "" : "s"} tagged — open to view
                      </span>
                    }
                  >
                    <ul className="tp-home__course-list">
                      {mappedCourses.map((course) => (
                        <li key={`${course.courseId || course.courseName}`}>
                          <span className="ds-strong">{course.courseName}</span>
                          {course.levels.length ? (
                            <span className="ds-text-subtle tp-home__course-levels">
                              {course.levels.join(" · ")}
                            </span>
                          ) : null}
                        </li>
                      ))}
                    </ul>
                  </Disclosure>
                )}
              </div>
            </div>
          </div>

          <div className="tp-home__toggles">
            <SwitchField
              id="enableForAllocationPrioritySwitch"
              label="Allocation Priority"
              checked={isAllocattionPriority}
              onChange={changeallocationPriority}
              disabled={readOnly}
              title={leaderDisabledTitle}
            />
            <SwitchField
              id="enableForNightSlotsSwitch"
              label="Enable for Night slot"
              checked={isNightSlotEnable}
              onChange={nightSlotToggle}
              disabled={readOnly}
              title={leaderDisabledTitle}
            />
            <SwitchField
              id="enableForPaidSwitch"
              label="Enable For Paid"
              checked={isPaidEnabled}
              onChange={handleToggle}
              disabled={readOnly}
              title={leaderDisabledTitle}
            />
          </div>

          <FormProfile teacherId={teacherId} credentialId={credentialId} teacherDetails={teacherDetails} fetchData={fetchData} />

          {/* Modal for Status Change */}
          <Modal isOpen={isModalOpen} toggle={toggleModal}>
            <ModalHeader toggle={toggleModal}>Change Teacher Status</ModalHeader>
            <ModalBody className="tp-home__modal-form">
              <Field label="Select status" id="statusSelect">
                {(control) => (
                  <Select
                    {...control}
                    value={selectedStatus}
                    onChange={(e) => {
                      setSelectedStatus(e.target.value);
                      setStatusReasonCode("");
                      setStatusReasonOther("");
                      setStatusReason("");
                      if (!isOffboardStatus(e.target.value)) setLastDate(null);
                    }}
                    options={STATUS_OPTIONS}
                  />
                )}
              </Field>

              {isOffboardStatus(selectedStatus) ? (
                <>
                  <Field
                    label={selectedStatus === "RESIGNED" ? "Resignation reason" : "Termination reason"}
                    id="statusReasonCode"
                    required
                  >
                    {(control) => (
                      <Select
                        {...control}
                        value={statusReasonCode}
                        onChange={(e) => {
                          setStatusReasonCode(e.target.value);
                          if (e.target.value !== OTHER_REASON) setStatusReasonOther("");
                        }}
                        options={[{ value: "", label: "Select a reason" }, ...offboardReasonOptions]}
                      />
                    )}
                  </Field>

                  {statusReasonCode === OTHER_REASON && (
                    <Field
                      label="Please specify"
                      id="statusReasonOther"
                      required
                      hint={`${statusReasonOther.length}/300`}
                    >
                      {(control) => (
                        <Input
                          {...control}
                          type="textarea"
                          rows={3}
                          maxLength={300}
                          value={statusReasonOther}
                          onChange={(e) => setStatusReasonOther(e.target.value.slice(0, 300))}
                          placeholder="Enter the other reason"
                        />
                      )}
                    </Field>
                  )}

                  <Field label="Last working day" id="lastDate" required>
                    {(control) => (
                      <DatePicker
                        id={control.id}
                        selected={lastDate}
                        onChange={(date: Date) => setLastDate(date)}
                        dateFormat="yyyy-MM-dd HH:mm:ss"
                        showTimeSelect
                        timeFormat="HH:mm"
                        timeIntervals={15}
                        timeCaption="Time"
                        className="ds-input"
                        placeholderText="Select last working day"
                        required
                      />
                    )}
                  </Field>
                </>
              ) : (
                <Field label="Reason" id="statusReason" required hint={`${statusReason.length}/300`}>
                  {(control) => (
                    <Input
                      {...control}
                      type="textarea"
                      rows={3}
                      maxLength={300}
                      value={statusReason}
                      onChange={(e) => setStatusReason(e.target.value.slice(0, 300))}
                      placeholder="Enter reason (max 300 characters)"
                    />
                  )}
                </Field>
              )}
            </ModalBody>
            <ModalFooter>
              <Button
                variant="primary"
                onClick={handleStatusChange}
                disabled={!canSubmitStatus}
              >
                {statusUpdating ? "Updating..." : "Update Status"}
              </Button>
            </ModalFooter>
          </Modal>

          <Modal isOpen={isNightSlotReasonModalOpen} toggle={nightSlotCancel}>
            <ModalHeader toggle={nightSlotCancel}>
              {nightSlotAction ? "Enable Night Slot?" : "Disable Night Slot?"}
            </ModalHeader>
            <ModalBody>
              Are you sure you want to {nightSlotAction ? "enable" : "disable"} night slots for this teacher?
            </ModalBody>
            <ModalFooter>
              <Button variant="secondary" onClick={nightSlotCancel}>Cancel</Button>
              <Button variant="primary" onClick={nightSlotConfirm}>Confirm</Button>
            </ModalFooter>
          </Modal>
        </>
      ) : (
        <Loader label="Loading teacher details..." />
      )}

      <Modal isOpen={isOtpModalOpen} toggle={() => setIsOtpModalOpen(false)}>
        <ModalHeader toggle={() => setIsOtpModalOpen(false)}>Login OTP</ModalHeader>
        <ModalBody className="tp-home__otp">
          <div className="tp-home__otp-digits">
            {otp?.toString().split("").map((digit, index) => (
              <span key={index} className="tp-home__otp-digit">
                {digit}
              </span>
            ))}
          </div>
          <Button
            variant="secondary"
            icon={<FaCopy aria-hidden />}
            onClick={() => {
              navigator.clipboard.writeText(otp?.toString() || '');
              toast.success('OTP copied to clipboard!');
            }}
          >
            Copy OTP
          </Button>
        </ModalBody>
        <ModalFooter>
          {/* You can add footer buttons here if needed */}
        </ModalFooter>
      </Modal>

      <Modal isOpen={showResetModal} toggle={() => setShowResetModal(false)}>
        <ModalHeader toggle={() => setShowResetModal(false)}>
          Confirm Reset OTP
        </ModalHeader>
        <ModalBody>
          Are you sure you want to reset the OTP for <b>{teacherDetails?.teacherProfileDetails?.mobileNumber}</b>?
        </ModalBody>
        <ModalFooter>
          <Button variant="secondary" onClick={() => setShowResetModal(false)}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={async () => {
              setResetLoading(true);
              try {
                await resetotp(teacherDetails?.teacherProfileDetails?.mobileNumber);
                toast.success("OTP reset successfully!");
                setShowResetModal(false);
              } catch (e) {
                toast.error("Failed to reset OTP");
              } finally {
                setResetLoading(false);
              }
            }}
            disabled={resetLoading}
          >
            {resetLoading ? "Resetting..." : "OK"}
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default Home;
